// extracted by mini-css-extract-plugin
module.exports = {"portal":"styles__portal__2Ykv0","wrapper":"styles__wrapper__1rkCU","btn-close":"styles__btn-close__2lMgt","btnClose":"styles__btn-close__2lMgt"};